import { FC } from "react"
import classes from "./styles.module.scss"
import { useMask } from "@react-input/mask"
import { Text, TextInput, TextInputProps } from "@mantine/core"

interface PhoneInputProps extends TextInputProps {
	label?: string
	required?: boolean
}

const options = {
	mask: "+7 (___) ___-__-__",
	replacement: { _: /\d/ },
}

export const PhoneInput: FC<PhoneInputProps> = ({ label, required, ...props }) => {
	const inputRef = useMask(options)

	return (
		<div className={classes.container}>
			{label && <Text className={classes.label}>{label}</Text>}
			<TextInput
				ref={inputRef}
				placeholder="+7"
				required={required}
				className={classes.input}
				{...props}
			/>
		</div>
	)
}
